import { Close } from "./Icons";
import { useUI } from "../data/UIContext";

export function HelpOverlay() {
  const ui = useUI();
  if (!ui.helpOpen) return null;
  return (
    <div className="help-overlay open" onClick={(e) => {
      if ((e.target as HTMLElement).classList.contains("help-overlay")) ui.setHelpOpen(false);
    }}>
      <div className="help-card">
        <div className="help-head">
          <h3>Keyboard shortcuts</h3>
          <button className="icon-btn" aria-label="Close" onClick={() => ui.setHelpOpen(false)}>
            <Close size={14} />
          </button>
        </div>
        <table>
          <tbody>
            <tr><td><kbd>/</kbd></td><td>Focus search</td></tr>
            <tr><td><kbd>t</kbd></td><td>Focus triage form</td></tr>
            <tr><td><kbd>1</kbd>–<kbd>9</kbd>, <kbd>0</kbd></td><td>Switch section (Backend → Graph)</td></tr>
            <tr><td><kbd>i</kbd></td><td>Declare incident</td></tr>
            <tr><td><kbd>Esc</kbd></td><td>Close panel / clear search</td></tr>
            <tr><td><kbd>?</kbd></td><td>Toggle this help</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
